import type { TourDefinition } from '../tours.types';


export const CASE2_FIRMA_ASICIACION_SIN_PLANTILLA_TOUR: TourDefinition = {
  id: 'case2_firma_asociacion_sin_plantilla_help',
  //route: '/firmas/firma',
  remember: true,
  steps: [
    {
      element: '[data-tour="case-firma-root"]',
      popover: {
        title: 'Asociación de firmantes',
        description:
          'En este paso defines los participantes de este proceso de firma; puedes seleccionar uno o más participantes para solicitar su firma.',
        side: 'bottom',
        align: 'center',
      },
    },

    {
      element: '[data-tour="btn-agregar-certificado"]',
      popover: {
        title: 'Agregar certificado',
        description:
          'Aquí puedes agregar los certificados de los participantes de firma.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '[data-tour="tab-certificados"]',
      popover: {
        title: 'Certificados',
        description:
          'Aquí podrás ver el detalle de todos los certificados agregados.',
        side: 'right',
        align: 'center',
      },
    },    
    {
      element: '[data-tour="firma-next"]',
      popover: {
        title: 'Continuar',
        description:
          'Cuando hayas definido los participantes, da clic en siguiente para pasar a la selección de áreas de firma.',
        side: 'left',
        align: 'center',
      },
    },
  ],
};
